// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Disclaimer — AB 3030 compliance */

.ai-disclaimer {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: 11px;
  color: var(--text-muted);
  line-height: 1.4;
  max-width: max-content;
}

.ai-disclaimer a {
  color: var(--text-subtle);
  text-decoration: underline;
  text-decoration-style: dotted;
}

.ai-disclaimer a:hover {
  color: var(--text-secondary);
}

/* Variant: inline within a page section */
.ai-disclaimer--inline {
  margin: var(--space-3) 0;
}

/* Variant: fixed bottom-right of a container */
.ai-disclaimer--footer {
  margin-top: auto;
  align-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/AIDisclaimer.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":["/* AI Disclaimer — AB 3030 compliance */\n\n.ai-disclaimer {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  background: var(--bg-surface);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  font-size: 11px;\n  color: var(--text-muted);\n  line-height: 1.4;\n  max-width: max-content;\n}\n\n.ai-disclaimer a {\n  color: var(--text-subtle);\n  text-decoration: underline;\n  text-decoration-style: dotted;\n}\n\n.ai-disclaimer a:hover {\n  color: var(--text-secondary);\n}\n\n/* Variant: inline within a page section */\n.ai-disclaimer--inline {\n  margin: var(--space-3) 0;\n}\n\n/* Variant: fixed bottom-right of a container */\n.ai-disclaimer--footer {\n  margin-top: auto;\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
